import { Component, OnInit, ViewChild, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { ModalComponent } from '../../../core/shared/modal/modal.component';
import { SystemVersion } from '../system-version.model';
import { NgForm } from '@angular/forms';
import { SystemVersionRest } from '../system-versions.rest';
import { SystemVersionHeader } from '../system-versions-header.model';
import { DictionaryRest } from '../../../dictionaries/dictionary/dictionary.rest';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';

@Component({
  selector: 'smp-systemversion',
  templateUrl: './system-version.component.html'
})
export class SystemVersionComponent implements OnInit, HasPermissions {
  permissions: Permissions;
  public dictionaries: any = [{ 'value': '', 'id': 0 }];
  public systemVersion: SystemVersion;
  private title: string;
  private editMode: boolean;
  private isEditable: boolean;
  private isSaving = false;
  
  @ViewChild(ModalComponent) private modal: ModalComponent;
  @ViewChild('systemVersionForm') systemVersionForm: NgForm;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter();

  constructor(
    private rest: SystemVersionRest,
    private dictionaryRest: DictionaryRest,
    private permissionService: PermissionsService) {
  }

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.modal.modalRoot.isShown === true && this.systemVersionForm.valid) {
      this.saveSystemVersion();
      event.preventDefault();
    }
  }

  public ngOnInit() {
    this.setPermissions("SystemVersion");
    this.modal.title = 'Dodaj wersję systemu';
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  public openForAdding(element: SystemVersionHeader, dictionaries: any) {
    this.editMode = false;
    this.dictionaries = dictionaries;
    this.isEditable = this.permissions.canAdd;
    this.systemVersion = new SystemVersion();
    this.systemVersion.universalDictionaryId = element.id;
    this.modal.open();
  }

  public openForEdit(row: SystemVersion, dictionaries: any) {
    this.editMode = true;
    this.dictionaries = dictionaries;
    this.isEditable = this.permissions.canEdit;
    this.systemVersion = row;
    this.modal.open();
  }

  public closeModal() {
    this.modal.close();
  }

  public saveSystemVersion() {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    const action = this.editMode ? this.rest.saveSystemVersion : this.rest.addSystemVersion;
    action.call(this.rest, this.systemVersion).subscribe((result: SystemVersion) => {
      if(result){
        this.modal.close();
        this.onSuccess.emit({ isAdded: !this.editMode, value: result });
        this.isSaving = false;
      }
    });
  }
}
